import { put } from '../../../../helpers/fetch';
import { buildURL } from '../../../../helpers/urls';

const setEventStatus = (slugDate, eventStatus) => {
  const url = buildURL('/events/');
  return put(url, { slugDate, data: { eventStatus } });
};

export default setEventStatus;
